<template>
  <div>
    <main v-if="isPc">
      <div
        v-if="!isStoreBooksLoading && getStoreCurrentBook"
        id="container"
        class="store_st_detail"
      >
        <!-- Location START -->
        <BaseSubbar :category="bookCategory" :subcategory="bookSubCategory" />
        <!-- Location END -->
        <!-- 도서 기본 정보 START -->
        <div class="section full">
          <div class="inner">
            <div class="detail_book">
              <div class="eplist">
                <div>
                  <div class="cover_wrap">
                    <!-- <img
                      v-if="getStoreCurrentBook.bookClassTp === 'FRN'"
                      class="global_sticker"
                      src="@/assets/images/svg/global_sticker.svg"
                      alt="해외도서"
                    /> -->
                    <div class="thum_wrap">
                      <img
                        v-if="isEbookEvent"
                        class="eventMark"
                        src="@/assets/images/eventmark2.png"
                        alt="이벤트마크"
                      />
                      <img
                        :src="getStoreCurrentBook.img"
                        :alt="getStoreCurrentBook.title"
                      />
                    </div>
                  </div>
                  <div
                    v-if="
                      getStoreCurrentBook.previewYn === 'Y' &&
                      getStoreCurrentBook.bookTp != 'BUNDLE'
                    "
                    class="preview_btn_wrap"
                  >
                    <a class="an_a miri" @click="showInViewer">
                      <!-- <span class="c_icon ico_view_preview"></span> -->
                      미리보기
                    </a>
                  </div>
                  <div
                    v-if="isTeacher && getStoreCurrentBook.bookTp != 'BUNDLE'"
                    class="preview_btn_wrap"
                    style="margin: 5px auto 0;"
                  >
                    <a class="an_a free_request" @click="toggleRequestModal">
                      교강사 증정요청
                      <!-- <img
                        src="@/assets/images/gift_bt_img.svg"
                        alt="교강사 증정요청"
                        style="width: 100%;"
                      /> -->
                    </a>
                  </div>
                </div>
                <div>
                  <div class="info_wrap">
                    <div class="row">
                      <p class="iconbox">
                        <span
                          :class="{ active: getStoreCurrentBook.hasEbook }"
                          class="meta_editer epub ebook"
                        >
                          e-Book
                        </span>
                        <span
                          v-if="checkEbookOnly"
                          class="meta_editer epub onlyEbook"
                        >
                          ONLY e-Book
                        </span>
                        <span
                          v-if="getSupplementExists"
                          class="meta_editer epub supplement"
                        >
                          부록 포함
                        </span>
                      </p>
                      <span
                        v-if="getStoreCurrentBook.subTitle"
                        class="sub_title"
                        >{{ getStoreCurrentBook.subTitle }}</span
                      >
                      <cite class="meta_title">
                        {{ getStoreCurrentBook.title }}
                      </cite>
                      <p class="meta_author">
                        <span class="sub">저자: </span>
                        {{ getStoreCurrentBook.author }}
                      </p>
                      <p
                        v-if="getStoreCurrentBook.translator"
                        class="meta_translator"
                      >
                        <span class="sub">역자: </span>
                        {{ getStoreCurrentBook.translator }}
                      </p>
                      <p class="meta_publisher">
                        <span class="sub">출판사: </span
                        >{{ getStoreCurrentBook.publisher }}
                      </p>
                      <p v-if="getStoreCurrentBook.date" class="meta_date">
                        <span class="sub">종이책 출판일: </span
                        >{{ getStoreCurrentBook.date }}
                      </p>
                      <p class="meta_ebook_date">
                        <span class="sub">전자책 출판일: </span
                        >{{ getStoreCurrentBook.epublishDate }}
                      </p>
                      <p v-if="getSupplementExists" class="meta_supplement">
                        <span class="sub">보조자료: </span
                        >{{ getSupplementFileNames[0] }}
                        <span v-if="getSupplementFileNames.length > 1">
                          외 {{ getSupplementFileNames.length - 1 }}건
                        </span>
                      </p>
                    </div>

                    <div class="row">
                      <div class="buy_option_wrap">
                        <ul class="select_list">
                          <li
                            v-if="unlimitPricePaper.listPrice"
                            class="list_price bd"
                          >
                            <span>종이책 정가</span>
                            <span>
                              <vue-intl-numberformat
                                locale="ko-KR"
                                format-style="decimal"
                                :currency="getCurrency.currency"
                                :number="unlimitPricePaper.listPrice"
                              />
                              <span>원</span>
                            </span>
                          </li>
                          <li class="list_price list_price_bgc">
                            <span>e-Book 정가</span>
                            <span
                              :class="{ yellow: paperPerEBookDiscount > 0 }"
                            >
                              <vue-intl-numberformat
                                locale="ko-KR"
                                format-style="decimal"
                                :currency="getCurrency.currency"
                                :number="localCurrencyPrice.price"
                              />
                              <span>원</span>
                              <span v-if="(paperPerEBookDiscount > 0)">
                                ({{ paperPerEBookDiscount }}%)
                              </span>
                            </span>
                          </li>
                          <!-- ********************* -->
                          <!-- PURCHASE OPTIONS LIST -->
                          <!-- ********************* -->
                          <li>
                            <span class="option_name">
                              구매 옵션
                              <span
                                v-if="getStoreCurrentBook.bookTp === 'BUNDLE'"
                                class="warning"
                              >
                                (!세트상품은 환불이 불가합니다.)
                              </span>
                            </span>
                            <span v-if="isEbookEvent" class="option_desc">
                              (신학기 도서대전 6개월 대여 할인 중)
                            </span>
                            <ul class="list_option_wrap">
                              <li
                                v-for="(option, idx) in getStoreCurrentBook
                                  .bookPrice.ebook.options"
                                :key="idx"
                                :class="{
                                  'on': idx === selected,
                                  'event': isEventOption(option),
                                  'hidden': option.salePrice == '0'
                                }"
                                @click="activeListOpt(idx)"
                              >
                                <button
                                  class="list_option"
                                  :class="{ 'active': showDeliveryOptions }"
                                  @click="selectPurchaseOption(option)"
                                >
                                  <span class="opt_desc">
                                    {{ option.optDesc }}
                                  </span>
                                  <span class="ar">
                                    <vue-intl-numberformat
                                      class="price"
                                      locale="ko-KR"
                                      format-style="decimal"
                                      :currency="getCurrency.currency"
                                      :number="option.salePrice"
                                    />
                                    <span>원</span>
                                    <span
                                      v-if="(option.rating > 0)"
                                      class="opt_rate"
                                    >
                                      ({{ option.rating }}%↓)
                                    </span>
                                  </span>
                                </button>
                              </li>
                            </ul>
                          </li>
                        </ul>
                        <!-- ******************** -->
                        <!-- TOTAL ITEM PRICE BAR -->
                        <!-- ******************** -->
                        <div class="price_calc">
                          <ol>
                            <li class="price_sum">
                              <p>
                                <span class="total_price">
                                  {{ $t('views.store.bookdetail.9955') }}
                                  <span class="price priceItem">
                                    <!-- TOTAL PRICE -->
                                    <vue-intl-numberformat
                                      class="price"
                                      format-style="decimal"
                                      :currency="getCurrency.currency"
                                      :number="totalPrice"
                                    >
                                    </vue-intl-numberformat>
                                    원
                                  </span>
                                </span>
                              </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 할인쿠폰 즉시 다운로드 버튼 -->
                  <div v-if="isEventOpen" class="btn_wrap coupon_wrap">
                    <div>
                      <button
                        class="event_box box_btn"
                        @click="oneTouchCouponDownload"
                      >
                        <img
                          class="img_download"
                          src="@/assets/images/download_24_01.png"
                        />
                        <span>10% 할인쿠폰</span>
                      </button>
                    </div>
                  </div>
                  <!-- TEMP -->
                  <div class="btn_wrap purchas_wrap">
                    <div class="bdsi_cart">
                      <button
                        class="gray_box box_btn"
                        tabindex="0"
                        @click="handlePurchase('cart')"
                      >
                        <!-- <span class="svg_buy_cart"></span> -->
                        <span class="an_t">
                          장바구니
                        </span>
                      </button>
                    </div>
                    <div class="bdsi_now" @click="handlePurchase('buyNow')">
                      <button class="box_btn">
                        <span class="an_t">
                          바로구매
                        </span>
                      </button>
                    </div>
                    <div v-if="showPaperLink" class="bdsi_f1">
                      <a
                        :href="getStoreCurrentBook.paperbookLink"
                        target="_blank"
                        class="box_btn"
                      >
                        <span class="an_t">
                          종이책
                        </span>
                      </a>
                    </div>
                    <!-- 선물 주석 -->
                    <!-- -->
                    <div
                      v-if="showGift"
                      class="bdsi_f1 bdsi_gift"
                      @click="handlePurchase('gift')"
                    >
                      <button class="box_btn">
                        <span class="an_t">
                          선물
                        </span>
                      </button>
                    </div>
                    <!-- -->
                    <!-- <div class="bdsi_f1" @click="goBuyBookLink"> -->
                  </div>
                  <p class="before_check">※ 구매 전 반드시 확인해 주세요.</p>
                  <ul class="desc_wrap">
                    <li class="desc_list">
                      <span
                        v-html="
                          '전자책 특성상 한 번 열람한 후에는 취소 및 환불이 불가능합니다. <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 미리보기를 통해 내용을 충분히 확인하신 후 신중하게 구매해 주세요.'
                        "
                      ></span>
                    </li>
                    <li class="desc_list">
                      <span
                        v-html="
                          'PDF 다운로드 및 인쇄는 제공되지 않습니다. <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(출판사 및 저작권자의 정책에 따라 별도의 파일 제공이 불가합니다.)'
                        "
                      ></span>
                    </li>
                    <!-- 선물 주석 -->
                    <li v-if="showGift" class="desc_list">
                      <span>
                        '선물하기'는 '구매(소장)' 옵션으로만 이용 가능합니다.
                      </span>
                    </li>
                  </ul>
                  <!-- / TEMP -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 도서 기본 정보 END-->

        <!-- *************** -->
        <!-- TAB BAR BUTTONS -->
        <!-- *************** -->
        <div class="section fill">
          <div class="inner pb-0">
            <!-- Tab START -->
            <div class="link_tab" data-tab-position="tab-book-info">
              <ul>
                <li :class="{ active: activeTab === 1 }">
                  <a
                    class="link_tab_menu"
                    tabindex="0"
                    @click="setActiveTab(1)"
                    @keypress.enter="setActiveTab(1)"
                  >
                    도서정보
                  </a>
                </li>
                <li :class="{ active: activeTab === 2 }">
                  <a
                    class="link_tab_menu"
                    tabindex="0"
                    @click="setActiveTab(2)"
                    @keypress.enter="setActiveTab(2)"
                  >
                    연관 도서
                  </a>
                </li>
              </ul>
            </div>
            <!-- Tab Box END -->
            <!-- ******************* -->
            <!-- TAB 1: BOOK DETAILS -->
            <!-- ******************* -->
            <div v-show="activeTab == 1" class="detail_book_introduce">
              <!-- Detail Box -->
              <BookDetailBox class="detailMargin" :book="getStoreCurrentBook" />
              <div class="box">
                <h3 class="sub_tit">{{ $t('views.store.bookdetail.5507') }}</h3>
                <div class="box_inner">
                  <p
                    v-for="(category, idx) in getStoreCurrentBook.categories"
                    :key="idx + '_' + category.id"
                    class="meta_itemlege"
                  >
                    <span>{{ category.label.split('>')[0] }}</span
                    ><span
                      v-if="category.label.split('>').length > 1"
                      class="svg_next"
                      >></span
                    >
                    <span v-if="category.label.split('>').length > 1">{{
                      category.label.split('>')[1]
                    }}</span>
                    <span
                      v-if="category.label.split('>').length > 2"
                      class="svg_next"
                      >></span
                    >
                    <span v-if="category.label.split('>').length > 2">{{
                      category.label.split('>')[2]
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="box">
                <h3 class="sub_tit">{{ $t('views.store.bookdetail.9765') }}</h3>
                <div class="box_inner">
                  <p class="meta_dscript">
                    <span
                      ref="description"
                      v-html="formattedDescription"
                    ></span>
                  </p>
                </div>
              </div>
              <!-- 저자소개 -->
              <div class="box">
                <h3 class="sub_tit">저자 소개</h3>
                <div class="box_inner">
                  <p class="meta_dscript">
                    <span
                      ref="description"
                      v-html="formattedAuthorDescription"
                    ></span>
                  </p>
                </div>
              </div>
              <div class="box bd_none">
                <h3 class="sub_tit">목차</h3>
                <div class="box_inner o-h">
                  <p class="meta_table review_more_wrap">
                    <span
                      ref="contents"
                      class="txt_overflow"
                      v-html="formattedContents"
                    >
                    </span>
                    <button
                      v-show="isContentLong"
                      type="button"
                      class="more_read_view"
                      :class="{ active: showFullContents }"
                      @click="toggleContents"
                    >
                      <span class="an_t">
                        {{ $t('views.store.bookdetail.2061') }}
                      </span>
                    </button>
                  </p>
                </div>
              </div>
              <div class="use_refund">
                <div class="box">
                  <h3 class="sub_tit">
                    ebook 구매/이용 안내
                  </h3>
                  <ul>
                    <li>
                      · 본 상품은 별도로 배송되지 않는 전자책 서비스입니다.
                    </li>
                    <li>
                      · 출판사 및 저작자들과의 협의 된 상품 외의 상품들은 인쇄
                      및 PDF로의 저장이 불가합니다.
                    </li>
                  </ul>
                </div>
                <div class="box">
                  <h3 class="sub_tit">
                    반품/교환/환불 안내
                  </h3>
                  <ul>
                    <li>
                      · eBook 소장 상품은 구매 후 다운로드 또는 스트리밍 재생을
                      하지 않은 경우에 한해 구매일로부터 14일 이내 주문 취소 및
                      환불이 가능합니다.
                    </li>
                    <li>
                      · 6개월 및 12개월 대여 상품의 경우, 구매 이후 환불이
                      불가능 하며, 이용 기간이 지난 후에는 대여 권한이 소멸
                      됩니다.
                    </li>
                    <li>
                      · 캠퍼스북 시스템의 오류 및 컨텐츠의 하자를 제외한
                      고객님의 개인적인 사정으로 인한 환불 및 교환은
                      불가능합니다.
                    </li>
                    <li>
                      · 마이페이지 > 구매목록 > 환불을 통해 신청 가능하고,
                      취소/반품 내역에서 확인 가능합니다.
                    </li>
                    <li>
                      · eBook 상품은 구매 후 바로 보기 하신 경우 주문 취소가
                      불가능합니다.
                    </li>
                  </ul>
                  <p>
                    더 자세한 사항은 캠퍼스북 이용약관
                    <router-link
                      :to="{ name: 'terms' }"
                      class="use_info"
                      target="_blank"
                      >[바로가기]</router-link
                    >
                    를 통해 더 자세히 보실 수 있습니다.
                  </p>
                </div>
                <div class="box">
                  <h3
                    class="sub_tit toggle"
                    :class="{ 'active': hiddenStates[0] }"
                    @click="toggleExplain(0)"
                  >
                    <span>ePUB이란?</span>
                    <button>
                      <img src="@/assets/images/explain.png" alt="더보기" />
                    </button>
                  </h3>
                  <transition
                    @before-enter="beforeEnter"
                    @enter="enter"
                    @leave="leave"
                  >
                    <div v-show="hiddenStates[0]" class="hidden_wrap">
                      <p>
                        eBook 파일과 단말기 간의 호환성 문제를 해결하기 위해
                        사용되는 국제 표준 파일 형식은 주로 EPUB 형식입니다.
                        <br />
                        EPUB 파일은 열린 표준이므로 대부분의 기기와 플랫폼에서
                        지원되며, 다음과 같은 기능을 제공합니다.
                      </p>
                      <ol>
                        <li>
                          1. 다양한 디지털 기기와 전자책 리더기에서 문제없이
                          읽을 수 있도록 설계되어 있습니다. 이를 통해 특정
                          기기에 종속되지 않고 독서 경험을 유지할 수 있습니다.
                        </li>
                        <li>
                          2. 반응형 레이아웃: 화면 크기에 맞게 텍스트와 이미지가
                          자동으로 조정되며, 특히 스마트폰이나 태블릿과 같은
                          다양한 화면 크기를 가진 장치에서 효율적인 <br />
                          읽기 경험을 보장합니다.
                        </li>
                        <li>
                          3. 다양한 콘텐츠: 텍스트뿐만 아니라 이미지, 동영상,
                          오디오 등의 멀티미디어 콘텐츠를 포함할 수 있어, 풍부한
                          독서 경험을 제공합니다.
                        </li>
                        <li>
                          4. 대체 포맷과의 비교: 예를 들어 PDF 파일은 고정된
                          레이아웃을 유지하여 인쇄물과 유사한 경험을 제공하지만,
                          글자 크기나 형식을 유연하게 변경하기 어려운 반면,
                          EPUB은 그 유연성으로 인해 다양한 기기에서 더 나은
                          사용자 경험을 제공합니다.
                        </li>
                      </ol>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ************** -->
        <!-- TAB 2: REVIEWS -->
        <!-- ************** -->
        <!-- <ReviewBox v-show="activeTab == 2" id="reviewBox" /> -->
        <!-- ******************** -->
        <!-- TAB 3: RELATED BOOKS -->
        <!-- ******************** -->
        <div v-show="activeTab == 2" class="relatedBooksTab">
          <!-- 연관 도서 START -->
          <div class="section full pb">
            <div class="inner" style="padding-bottom: 52px;">
              <h2>
                <span class="sec_title min">
                  <span>
                    {{ $t('views.store.bookdetail.4633') }}
                  </span>
                </span>
              </h2>
              <div class="eplist item_columns_6">
                <ul class="item_list">
                  <BaseBook
                    v-for="(book, idx) in getStoreCurrentBook.related.slice(
                      0,
                      6
                    )"
                    :key="idx"
                    :book="book"
                  />
                </ul>
              </div>
            </div>
          </div>
          <!-- 연관 도서 END -->
        </div>
        <!-- 헬프 데스크 START -->
        <HelpDesk />
        <!-- POD INFO MODAL -->
        <transition name="modal-fade" @click="togglePodModal">
          <Modal v-if="showPodModal" @close="togglePodModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a class="btn_ly_close svg_close" @click="togglePodModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner">
                  <strong>{{ $t('views.store.bookdetail.pod5') }}</strong>
                  <p>{{ $t('views.store.bookdetail.printOnDemand') }}</p>
                  <div class="btnWrap">
                    <button class="box_btn w-full" @click="togglePodModal">
                      <span class="an_t">{{
                        $t('library.deletemodal.close')
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </transition>
        <transition v-on-clickaway="toggleBuyNowModal" name="modal-fade">
          <Modal v-if="showBuyNowModal" @close="toggleBuyNowModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a class="btn_ly_close svg_close" @click="toggleBuyNowModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner cart_alert_wrap">
                  <div class="cell">
                    <div class="msgimg">
                      <img
                        src="@/assets/images/svg/ico_popup_cart.svg"
                        class="svg_msg_cart"
                        alt="carticon"
                      />
                    </div>
                    <div class="cart_desc_wrap">
                      <div class="cart_desc_head">
                        {{ $t('views.store.bookdetail.7073') }}
                      </div>
                      <div class="cart_desc_body">
                        <span>{{ $t('views.store.bookdetail.8383') }}</span>
                        <br />
                        <span>{{ $t('views.store.bookdetail.8384') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="btn_wrap">
                    <button class="box_btn dull" @click="toggleBuyNowModal">
                      <span class="an_t">{{
                        $t('library.deletemodal.cancel')
                      }}</span>
                    </button>
                    <button class="box_btn" @click="goBuyNow">
                      <span class="an_t">
                        {{ $t('views.store.bookdetail.9790') }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal v-if="showCartModal" @close="toggleCartModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a class="btn_ly_close svg_close" @click="toggleCartModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner cart_alert_wrap">
                  <div class="cell">
                    <div class="msgimg">
                      <img
                        src="@/assets/images/svg/ico_popup_cart.svg"
                        class="svg_msg_cart"
                        alt="carticon"
                      />
                    </div>
                    <span class="cart_alert_msg">{{
                      $t('views.store.bookdetail.7074')
                    }}</span>
                  </div>
                  <div class="btn_wrap">
                    <button class="box_btn dull" @click="toggleCartModal">
                      <span class="an_t">{{
                        $t('library.deletemodal.ok')
                      }}</span>
                    </button>
                    <button class="box_btn" @click="navigateToCart">
                      <span class="an_t">
                        {{ $t('views.store.bookdetail.2771') }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </transition>
        <transition name="modal-fade">
          <Modal v-if="showDeliveryInfoFrame">
            <div v-on-clickaway="closeDeliveryInfoToggle" class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a
                    class="btn_ly_close svg_close"
                    @click="closeDeliveryInfoToggle"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner">
                  <ul class="scroll_wrap">
                    <li
                      v-for="(d, i) in getDeliveryInfo"
                      :key="i"
                      class="delivery_name"
                    >
                      {{ d.emsCountryNm }}
                    </li>
                  </ul>
                </div>
                <div class="btnWrap">
                  <button class="box_btn" @click="closeDeliveryInfoToggle">
                    <span class="an_t">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </transition>
        <!-- ERROR MODAL START -->
        <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
          <Modal v-if="showErrorModal" @close="toggleErrorModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner">
                  <p>
                    {{
                      getCartErrorMessage ? getCartErrorMessage : errorMessage
                    }}
                  </p>
                  <div class="btnWrap">
                    <button class="box_btn" @click="toggleErrorModal">
                      <span class="an_t">닫기</span>
                    </button>
                    <router-link
                      v-if="!errorMessage.includes('구매 항목을 선택하세요.')"
                      class="box_btn"
                      to="/cart"
                    >
                      <span class="an_t">장바구니 가기</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </transition>
        <!-- ERROR MODAL END -->
        <!-- NEW MODAL -->
        <transition v-on-clickaway="toggleRequestModal" name="modal-fade">
          <Modal v-if="showRequestModal" @close="toggleRequestModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a class="btn_ly_close svg_close" @click="toggleRequestModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner">
                  <p class="request">
                    증정 요청하시는 분을 확인하기 위하여
                  </p>
                  <p class="request">
                    요청한 도서의 출판사에 회원정보가 전달됩니다.
                  </p>
                  <p class="request">
                    증정을 요청하시려면 "요청"버튼을 클릭하세요.
                  </p>
                  <div class="btnWrap no_pd">
                    <button class="box_btn test" @click="requestPresent">
                      <span class="an_t">요청</span>
                    </button>
                    <button class="box_btn test" @click="toggleRequestModal">
                      <span class="an_t">취소</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </transition>
        <Transition name="modal-fade">
          <Modal v-if="showCouponModal" @close="toggleCouponModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a class="btn_ly_close svg_close" @click="toggleCouponModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner cart_alert_wrap">
                  <div class="cell">
                    <span class="cart_alert_msg">
                      <p>{{ couponMessage }}</p>
                      <!-- <p>할인 쿠폰이 발급되었습니다.</p> -->
                      <!-- <p>주문시 사용가능합니다.</p> -->
                    </span>
                  </div>
                  <div class="btn_wrap">
                    <button class="box_btn dull" @click="toggleCouponModal">
                      <span class="an_t">{{
                        $t('library.deletemodal.ok')
                      }}</span>
                    </button>
                    <button class="box_btn" @click="navigateToCoupon">
                      <span class="an_t">
                        쿠폰함으로 이동
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal v-if="showCouponErrorModal" @close="toggleCouponErrorModal">
            <div class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a
                    class="btn_ly_close svg_close"
                    @click="toggleCouponErrorModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner cart_alert_wrap">
                  <div class="cell">
                    <span class="cart_alert_msg">
                      <!-- <p>쿠폰 수령 횟수를 초과했습니다</p> -->
                      <!-- <p>쿠폰은 3회까지 다운로드 가능합니다</p> -->
                      <p>{{ couponErrorMessage }}</p>
                    </span>
                  </div>
                  <div class="btn_wrap">
                    <button
                      class="box_btn dull"
                      @click="toggleCouponErrorModal"
                    >
                      <span class="an_t">{{
                        $t('library.deletemodal.ok')
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </Transition>
        <!-- 학지사메디컬(성인간호학) 예외처리 -->
        <transition v-on-clickaway="toggleAdultNursingModal" name="modal-fade">
          <Modal v-if="showAdultNursingModal" @close="toggleAdultNursingModal">
            <div class="ly_pop_wrap adult_nursing">
              <div class="ly_pop_content ly_pop_msg ly_txt">
                <div class="ly_pop_head">
                  <a
                    class="btn_ly_close svg_close"
                    @click="toggleAdultNursingModal"
                    ><span>{{ $t('library.deletemodal.close') }}</span></a
                  >
                </div>
                <div class="ly_inner cart_alert_wrap">
                  <div class="cell">
                    <div class="cart_desc_wrap">
                      <div class="cart_desc_head">
                        <span class="star">*</span> 구매하실 고객님의 <br />
                        <span class="line_bottom">학교를 선택해 주세요.</span>
                      </div>
                      <div class="cart_desc_body">
                        <div class="put_wrap">
                          <input
                            id="unicol"
                            v-model="unicolNm"
                            class="input_t put_college"
                            name="unicol"
                            placeholder="학교를 선택해 주세요"
                            readonly="readonly"
                            @click="toggleUnicolModal"
                          />
                          <button
                            class="college_search"
                            @click="toggleUnicolModal"
                          >
                            검색
                          </button>
                        </div>
                        <p class="because">
                          ※저자와의 계약 사항에 따라 학교 정보를 입력해야 도서
                          구매가 가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="btn_wrap">
                    <button class="box_btn dull" @click="college_register">
                      확인
                    </button>
                  </div>
                </div>
                <unicolModal
                  v-if="isShowUnicol"
                  @close="toggleUnicolModal"
                  @unicolInfo="selectUnicol"
                />
              </div>
            </div>
          </Modal>
        </transition>
      </div>
    </main>
    <main v-if="isMobile">
      <div
        v-if="!isStoreBooksLoading && getStoreCurrentBook"
        class="store_st_detail inner"
      >
        <!-- Location START -->
        <BaseSubbar :category="bookCategory" :subcategory="bookSubCategory" />
        <!-- Location END -->
        <!-- 도서 기본 정보 START -->
        <section class="detail_section">
          <figure class="cover_wrap">
            <!-- <img
              v-if="getStoreCurrentBook.bookClassTp === 'FRN'"
              class="global_sticker"
              src="@/assets/images/svg/global_sticker.svg"
              alt="해외도서"
            /> -->
            <img
              v-if="isEbookEvent"
              class="eventMark"
              src="@/assets/images/eventmark2.png"
              alt="이벤트마크"
            />
            <img
              :src="getStoreCurrentBook.img"
              :alt="getStoreCurrentBook.title"
              class="book_img"
            />
            <!-- 미리보기 -->
            <div
              v-if="
                getStoreCurrentBook.previewYn === 'Y' &&
                getStoreCurrentBook.bookTp != 'BUNDLE'
              "
              class="preview_btn_wrap"
            >
              <a class="preview_link" @click="showInViewer">
                미리보기
              </a>
            </div>
            <!-- 교강사 증정요청 -->
            <div
              v-if="isTeacher && getStoreCurrentBook.bookTp != 'BUNDLE'"
              class="preview_btn_wrap"
            >
              <a
                class="teach_link"
                style="background: transparent; border: none;"
                @click="toggleRequestModal"
                ><img
                  src="@/assets/images/gift_bt_img.svg"
                  alt="교강사 증정요청"
                  style="width: 100%;"
                />
              </a>
            </div>
            <figcaption>
              <div class="book_info">
                <p class="iconbox">
                  <span
                    :class="{ active: getStoreCurrentBook.hasEbook }"
                    class="meta_editer epub ebook"
                  >
                    e-Book
                  </span>
                  <span
                    v-if="checkEbookOnly"
                    class="meta_editer epub onlyEbook"
                  >
                    ONLY e-Book
                  </span>
                  <span
                    v-if="getSupplementExists"
                    class="meta_editer epub supplement"
                  >
                    부록 포함
                  </span>
                </p>
                <span v-if="getStoreCurrentBook.subTitle" class="sub_title">
                  {{ getStoreCurrentBook.subTitle }}
                </span>
                <cite class="book_title">
                  {{ getStoreCurrentBook.title }}
                </cite>
                <ul class="book_source">
                  <li class="book_author">
                    저자 : {{ getStoreCurrentBook.author }}
                  </li>
                  <li
                    v-if="getStoreCurrentBook.translator"
                    class="book_translator"
                  >
                    역자 : {{ getStoreCurrentBook.translator }}
                  </li>
                  <li class="book_publisher">
                    출판사 : {{ getStoreCurrentBook.publisher }}
                  </li>
                </ul>
              </div>
            </figcaption>
          </figure>
          <div class="row">
            <ul class="purchase_option">
              <li
                v-for="(option, idx) in getStoreCurrentBook.bookPrice.ebook
                  .options"
                :key="idx"
                :class="{
                  'background_style': option.rating > 0,
                  'hidden': option.salePrice == '0'
                }"
                @click="activeListOpt(idx)"
              >
                <button class="list_option">
                  <span class="opt_desc">
                    {{ option.optDesc }}
                  </span>
                  <span class="ar">
                    <span v-if="(option.rating > 0)" class="opt_rate">
                      ({{ option.rating }}%↓)
                    </span>
                    <vue-intl-numberformat
                      class="value"
                      locale="ko-KR"
                      format-style="decimal"
                      :currency="getCurrency.currency"
                      :number="option.salePrice"
                    />
                    원
                  </span>
                </button>
              </li>
            </ul>
          </div>
          <!-- 할인쿠폰 즉시 다운로드 버튼 -->
          <div v-if="isEventOpen" class="btn_wrap coupon_wrap">
            <span>10% 할인</span>
            <button class="event_box box_btn" @click="oneTouchCouponDownload">
              <span>쿠폰받기</span>
              <img
                class="img_download"
                src="@/assets/images/download_24_01.png"
              />
            </button>
          </div>
        </section>

        <!-- 도서 기본 정보 END-->
        <!-- *************** -->

        <p
          class="before_check"
          :class="{ 'active': hiddenStates[1] }"
          @click="toggleExplain(1)"
        >
          ※ 구매 전 반드시 확인해 주세요.
          <button>
            <img src="@/assets/images/explain.png" alt="더보기" />
          </button>
        </p>
        <ul v-show="hiddenStates[1]" class="desc_wrap">
          <li class="desc_list">
            <span
              v-html="
                '전자책 특성상 한 번 열람한 후에는 취소 및 환불이 불가능합니다. <br /> &nbsp;&nbsp;&nbsp; 미리보기를 통해 내용을 충분히 확인하신 후 신중하게 구매해 주세요.'
              "
            ></span>
          </li>
          <li class="desc_list">
            <span
              v-html="
                'PDF 다운로드 및 인쇄는 제공되지 않습니다. <br /> &nbsp;&nbsp;&nbsp;(출판사 및 저작권자의 정책에 따라 별도의 파일 제공이 불가합니다.)'
              "
            ></span>
          </li>
          <!-- 선물 주석 -->
          <li v-if="showGift" class="desc_list">
            <span>
              '선물하기'는 '구매(소장)' 옵션으로만 이용 가능합니다.
            </span>
          </li>
        </ul>

        <!-- TAB BAR BUTTONS -->
        <!-- *************** -->
        <section class="detail_section mt">
          <!-- Tab START -->
          <ul class="tab_link" data-tab-position="tab-book-info">
            <li :class="{ active: activeTab === 1 }">
              <a
                class="link_tab_menu"
                tabindex="0"
                @click="setActiveTab(1)"
                @keypress.enter="setActiveTab(1)"
              >
                {{ $t('views.store.bookdetail.3706') }}
              </a>
            </li>
            <li :class="{ active: activeTab === 2 }">
              <a
                class="link_tab_menu"
                tabindex="0"
                @click="setActiveTab(2)"
                @keypress.enter="setActiveTab(2)"
              >
                {{ $t('views.store.bookdetail.9026') }}
              </a>
            </li>
          </ul>
          <!-- Tab Box END -->
          <!-- ******************* -->
          <!-- TAB 1: BOOK DETAILS -->
          <!-- ******************* -->
          <div v-show="activeTab == 1" class="detail_book_introduce">
            <!-- Detail Box -->
            <BookDetailBox class="detailMargin" :book="getStoreCurrentBook" />
            <div class="box">
              <h3 class="sub_tit">카테고리 정보</h3>
              <div class="box_inner">
                <p
                  v-for="(category, idx) in getStoreCurrentBook.categories"
                  :key="idx + '_' + category.id"
                  class="meta_itemlege"
                >
                  <span>{{ category.label.split('>')[0] }}</span
                  ><span
                    v-if="category.label.split('>').length > 1"
                    class="svg_next"
                    >></span
                  >
                  <span v-if="category.label.split('>').length > 1">{{
                    category.label.split('>')[1]
                  }}</span>
                  <span
                    v-if="category.label.split('>').length > 2"
                    class="svg_next"
                    >></span
                  >
                  <span v-if="category.label.split('>').length > 2">{{
                    category.label.split('>')[2]
                  }}</span>
                </p>
              </div>
            </div>
            <!-- 책 소개 -->
            <div v-if="formattedDescription" class="box">
              <h3 class="sub_tit">책 소개</h3>
              <div class="box_inner">
                <p class="meta_dscript">
                  <span ref="description" v-html="formattedDescription"></span>
                </p>
              </div>
            </div>
            <!-- 저자소개 -->
            <div v-if="formattedAuthorDescription" class="box">
              <h3 class="sub_tit">저자 소개</h3>
              <div class="box_inner">
                <p class="meta_dscript">
                  <span
                    ref="description"
                    v-html="formattedAuthorDescription"
                  ></span>
                </p>
              </div>
            </div>
            <!-- 목차 -->
            <div v-if="formattedContents" class="box bd_none">
              <h3 class="sub_tit">목차</h3>
              <div class="box_inner o-h">
                <p class="meta_table review_more_wrap">
                  <span
                    ref="contents"
                    class="txt_overflow"
                    v-html="formattedContents"
                  >
                  </span>
                  <button
                    v-show="isContentLong"
                    type="button"
                    class="more_read_view"
                    :class="{ active: showFullContents }"
                    @click="toggleContents"
                  >
                    <span class="an_t">
                      {{ $t('views.store.bookdetail.2061') }}
                    </span>
                  </button>
                </p>
              </div>
            </div>
            <div class="use_refund">
              <div class="box">
                <h3 class="sub_tit">
                  ebook 구매/이용 안내
                </h3>
                <ul>
                  <li>· 본 상품은 별도로 배송되지 않는 전자책 서비스입니다.</li>
                  <li>
                    · 출판사 및 저작자들과의 협의 된 상품 외의 상품들은 인쇄 및
                    PDF로의 저장이 불가합니다.
                  </li>
                </ul>
              </div>
              <div class="box">
                <h3 class="sub_tit">
                  반품/교환/환불 안내
                </h3>
                <ul>
                  <li>
                    · eBook 소장 상품은 구매 후 다운로드 또는 스트리밍 재생을
                    하지 않은 경우에 한해 구매일로부터 14일 이내 주문 취소 및
                    환불이 가능합니다.
                  </li>
                  <li>
                    · 6개월 및 12개월 대여 상품의 경우, 구매 이후 환불이 불가능
                    하며, 이용 기간이 지난 후에는 대여 권한이 소멸 됩니다.
                  </li>
                  <li>
                    · 캠퍼스북 시스템의 오류 및 컨텐츠의 하자를 제외한 고객님의
                    개인적인 사정으로 인한 환불 및 교환은 불가능합니다.
                  </li>
                  <li>
                    · 마이페이지 > 구매목록 > 환불을 통해 신청 가능하고,
                    취소/반품 내역에서 확인 가능합니다.
                  </li>
                  <li>
                    · eBook 상품은 구매 후 바로 보기 하신 경우 주문 취소가
                    불가능합니다.
                  </li>
                </ul>
                <p>
                  더 자세한 사항은 캠퍼스북 이용약관
                  <router-link :to="{ name: 'terms' }" class="use_info"
                    >[바로가기]</router-link
                  >
                  를 통해 더 자세히 보실 수 있습니다.
                </p>
              </div>
              <div class="box">
                <h3
                  class="sub_tit toggle"
                  :class="{ 'active': hiddenStates[0] }"
                  @click="toggleExplain(0)"
                >
                  <span>ePUB이란?</span>
                  <button>
                    <img src="@/assets/images/explain.png" alt="더보기" />
                  </button>
                </h3>
                <transition
                  @before-enter="beforeEnter"
                  @enter="enter"
                  @leave="leave"
                >
                  <div v-show="hiddenStates[0]" class="hidden_wrap">
                    <p>
                      eBook 파일과 단말기 간의 호환성 문제를 해결하기 위해
                      사용되는 국제 표준 파일 형식은 주로 EPUB 형식입니다.
                      <br />
                      EPUB 파일은 열린 표준이므로 대부분의 기기와 플랫폼에서
                      지원되며, 다음과 같은 기능을 제공합니다.
                    </p>
                    <ol>
                      <li>
                        1. 다양한 디지털 기기와 전자책 리더기에서 문제없이 읽을
                        수 있도록 설계되어 있습니다. 이를 통해 특정 기기에
                        종속되지 않고 독서 경험을 유지할 수 있습니다.
                      </li>
                      <li>
                        2. 반응형 레이아웃: 화면 크기에 맞게 텍스트와 이미지가
                        자동으로 조정되며, 특히 스마트폰이나 태블릿과 같은
                        다양한 화면 크기를 가진 장치에서 효율적인 읽기 경험을
                        보장합니다.
                      </li>
                      <li>
                        3. 다양한 콘텐츠: 텍스트뿐만 아니라 이미지, 동영상,
                        오디오 등의 멀티미디어 콘텐츠를 포함할 수 있어, 풍부한
                        독서 경험을 제공합니다.
                      </li>
                      <li>
                        4. 대체 포맷과의 비교: 예를 들어 PDF 파일은 고정된
                        레이아웃을 유지하여 인쇄물과 유사한 경험을 제공하지만,
                        글자 크기나 형식을 유연하게 변경하기 어려운 반면, EPUB은
                        그 유연성으로 인해 다양한 기기에서 더 나은 사용자 경험을
                        제공합니다.
                      </li>
                    </ol>
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <!-- ************** -->
          <!-- TAB 2: REVIEWS -->
          <!-- ************** -->
          <!-- <ReviewBox v-show="activeTab == 2" id="reviewBox" /> -->
          <!-- ******************** -->
          <!-- TAB 3: RELATED BOOKS -->
          <!-- ******************** -->
          <div v-show="activeTab == 2" class="relatedBooksTab">
            <!-- 연관 도서 START -->
            <div>
              <h2>
                <span class="sec_title min">
                  <span>
                    {{ $t('views.store.bookdetail.4633') }}
                  </span>
                </span>
              </h2>
              <div class="eplist item_columns_6">
                <ul class="item_list">
                  <li
                    v-for="(book, idx) in getStoreCurrentBook.related.slice(
                      0,
                      6
                    )"
                    :key="idx"
                  >
                    <BaseBook :key="idx" :book="book" />
                  </li>
                </ul>
              </div>
            </div>
            <!-- 연관 도서 END -->
          </div>
          <!-- POD INFO MODAL -->
          <transition name="modal-fade" @click="togglePodModal">
            <Modal v-if="showPodModal" @close="togglePodModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a class="btn_ly_close svg_close" @click="togglePodModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner">
                    <strong>{{ $t('views.store.bookdetail.pod5') }}</strong>
                    <p>{{ $t('views.store.bookdetail.printOnDemand') }}</p>
                    <div class="btnWrap">
                      <button class="box_btn w-full" @click="togglePodModal">
                        <span class="an_t">{{
                          $t('library.deletemodal.close')
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </transition>
          <transition v-on-clickaway="toggleBuyNowModal" name="modal-fade">
            <Modal v-if="showBuyNowModal" @close="toggleBuyNowModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a class="btn_ly_close svg_close" @click="toggleBuyNowModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner cart_alert_wrap">
                    <div class="cell">
                      <div class="msgimg">
                        <img
                          src="@/assets/images/svg/ico_popup_cart.svg"
                          class="svg_msg_cart"
                          alt="carticon"
                        />
                      </div>
                      <div class="cart_desc_wrap">
                        <div class="cart_desc_head">
                          {{ $t('views.store.bookdetail.7073') }}
                        </div>
                        <div class="cart_desc_body">
                          <span>{{ $t('views.store.bookdetail.8383') }}</span>
                          <br />
                          <span>{{ $t('views.store.bookdetail.8384') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="btn_wrap">
                      <button class="box_btn dull" @click="toggleBuyNowModal">
                        <span class="an_t">{{
                          $t('library.deletemodal.cancel')
                        }}</span>
                      </button>
                      <button class="box_btn" @click="goBuyNow">
                        <span class="an_t">
                          {{ $t('views.store.bookdetail.9790') }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal v-if="showCartModal" @close="toggleCartModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a class="btn_ly_close svg_close" @click="toggleCartModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner cart_alert_wrap">
                    <div class="cell">
                      <div class="msgimg">
                        <img
                          src="@/assets/images/svg/ico_popup_cart.svg"
                          class="svg_msg_cart"
                          alt="carticon"
                        />
                      </div>
                      <span class="cart_alert_msg">{{
                        $t('views.store.bookdetail.7074')
                      }}</span>
                    </div>
                    <div class="btn_wrap">
                      <button class="box_btn dull" @click="toggleCartModal">
                        <span class="an_t">{{
                          $t('library.deletemodal.ok')
                        }}</span>
                      </button>
                      <button class="box_btn" @click="navigateToCart">
                        <span class="an_t">
                          {{ $t('views.store.bookdetail.2771') }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </transition>
          <transition name="modal-fade">
            <Modal v-if="showDeliveryInfoFrame">
              <div v-on-clickaway="closeDeliveryInfoToggle" class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a
                      class="btn_ly_close svg_close"
                      @click="closeDeliveryInfoToggle"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner">
                    <ul class="scroll_wrap">
                      <li
                        v-for="(d, i) in getDeliveryInfo"
                        :key="i"
                        class="delivery_name"
                      >
                        {{ d.emsCountryNm }}
                      </li>
                    </ul>
                  </div>
                  <div class="btnWrap">
                    <button class="box_btn" @click="closeDeliveryInfoToggle">
                      <span class="an_t">{{
                        $t('library.deletemodal.close')
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </transition>
          <!-- ERROR MODAL START -->
          <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
            <Modal v-if="showErrorModal" @close="toggleErrorModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner">
                    <p>
                      {{
                        getCartErrorMessage ? getCartErrorMessage : errorMessage
                      }}
                    </p>
                    <div class="btnWrap">
                      <button class="box_btn" @click="toggleErrorModal">
                        <span class="an_t">닫기</span>
                      </button>
                      <button class="box_btn pd" @click="toggleErrorModal">
                        <span class="an_t">장바구니 가기</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </transition>
          <!-- ERROR MODAL END -->
          <!-- NEW MODAL -->
          <transition v-on-clickaway="toggleRequestModal" name="modal-fade">
            <Modal v-if="showRequestModal" @close="toggleRequestModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a
                      class="btn_ly_close svg_close"
                      @click="toggleRequestModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner">
                    <p class="request">
                      증정 요청하시는 분을 확인하기 위하여
                    </p>
                    <p class="request">
                      요청한 도서의 출판사에 회원정보가 전달됩니다.
                    </p>
                    <p class="request">
                      증정을 요청하시려면 "요청"버튼을 클릭하세요.
                    </p>
                    <div class="btnWrap no_pd">
                      <button class="box_btn test" @click="requestPresent">
                        <span class="an_t">요청</span>
                      </button>
                      <button class="box_btn test" @click="toggleRequestModal">
                        <span class="an_t">취소</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </transition>
          <Transition name="modal-fade">
            <Modal v-if="showCouponModal" @close="toggleCouponModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a class="btn_ly_close svg_close" @click="toggleCouponModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner cart_alert_wrap">
                    <div class="cell">
                      <span class="cart_alert_msg">
                        <p>{{ couponMessage }}</p>
                        <!-- <p>할인 쿠폰이 발급되었습니다.</p> -->
                        <!-- <p>주문시 사용가능합니다.</p> -->
                      </span>
                    </div>
                    <div class="btn_wrap">
                      <button class="box_btn dull" @click="toggleCouponModal">
                        <span class="an_t">{{
                          $t('library.deletemodal.ok')
                        }}</span>
                      </button>
                      <button class="box_btn" @click="navigateToCoupon">
                        <span class="an_t">
                          쿠폰함으로 이동
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal v-if="showCouponErrorModal" @close="toggleCouponErrorModal">
              <div class="ly_pop_wrap">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a
                      class="btn_ly_close svg_close"
                      @click="toggleCouponErrorModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner cart_alert_wrap">
                    <div class="cell">
                      <span class="cart_alert_msg">
                        <!-- <p>쿠폰 수령 횟수를 초과했습니다</p> -->
                        <!-- <p>쿠폰은 3회까지 다운로드 가능합니다</p> -->
                        <p>{{ couponErrorMessage }}</p>
                      </span>
                    </div>
                    <div class="btn_wrap">
                      <button
                        class="box_btn dull"
                        @click="toggleCouponErrorModal"
                      >
                        <span class="an_t">{{
                          $t('library.deletemodal.ok')
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </Transition>
          <!-- 학지사메디컬(성인간호학) 예외처리 -->
          <transition
            v-on-clickaway="toggleAdultNursingModal"
            name="modal-fade"
          >
            <Modal
              v-if="showAdultNursingModal"
              @close="toggleAdultNursingModal"
            >
              <div class="ly_pop_wrap adult_nursing">
                <div class="ly_pop_content ly_pop_msg ly_txt">
                  <div class="ly_pop_head">
                    <a
                      class="btn_ly_close svg_close"
                      @click="toggleAdultNursingModal"
                      ><span>{{ $t('library.deletemodal.close') }}</span></a
                    >
                  </div>
                  <div class="ly_inner cart_alert_wrap">
                    <div class="cell">
                      <div class="cart_desc_wrap">
                        <div class="cart_desc_head">
                          <span class="star">*</span> 구매하실 고객님의 <br />
                          <span class="line_bottom">학교를 선택해 주세요.</span>
                        </div>
                        <div class="cart_desc_body">
                          <div class="put_wrap">
                            <input
                              id="unicol"
                              v-model="unicolNm"
                              class="input_t put_college"
                              name="unicol"
                              placeholder="학교를 선택해 주세요"
                              readonly="readonly"
                              @click="toggleUnicolModal"
                            />
                            <button
                              class="college_search"
                              @click="toggleUnicolModal"
                            >
                              검색
                            </button>
                          </div>
                          <p class="because">
                            ※저자와의 계약 사항에 따라 학교 정보를 입력해야 도서
                            구매가 가능합니다.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="btn_wrap">
                      <button class="box_btn dull" @click="college_register">
                        확인
                      </button>
                    </div>
                  </div>
                  <unicolModal
                    v-if="isShowUnicol"
                    @close="toggleUnicolModal"
                    @unicolInfo="selectUnicol"
                  />
                </div>
              </div>
            </Modal>
          </transition>
        </section>
        <section class="puchase_wrap" :class="{ 'on': puchase }">
          <i class="arrow" :class="{ 'on': puchase }" @click="hideBg"
            ><!--css--></i
          >
          <button
            class="purchase_btn"
            :class="{ 'off': puchase }"
            @click="showPuchase"
          >
            구매하기
          </button>
          <div class="option_wrap" :class="{ 'translate': puchase }">
            <div
              class="choice"
              :class="{ 'on': !optionSelect }"
              @click="optionChoice"
            >
              옵션 선택
            </div>
            <ul
              class="list_option_wrap"
              :class="{ 'on': optionSelect }"
              @click="optionChoice"
            >
              <li
                v-for="(option, idx) in getStoreCurrentBook.bookPrice.ebook
                  .options"
                :key="idx"
                :class="{
                  'on': idx === selected,
                  'event': isEventOption(option),
                  'hidden': option.salePrice == '0'
                }"
                @click="activeListOpt(idx)"
              >
                <button
                  class="list_option"
                  :class="{ 'active': showDeliveryOptions }"
                  @click="selectPurchaseOption(option)"
                >
                  <span class="opt_desc">
                    {{ option.optDesc }}
                  </span>
                  <span class="ar">
                    <span v-if="(option.rating > 0)" class="opt_rate">
                      ({{ option.rating }}%↓)
                    </span>
                    <vue-intl-numberformat
                      class="value"
                      locale="ko-KR"
                      format-style="decimal"
                      :currency="getCurrency.currency"
                      :number="option.salePrice"
                    />
                    원
                  </span>
                </button>
              </li>
            </ul>
          </div>
          <!-- 선택한 상품 -->
          <div
            ref="selectedItem"
            class="selected_item"
            :class="{ 'on': !optionSelect }"
          >
            <span class="sel_type">{{
              selectedOptions.length > 0 ? selectedOptions[0].optDesc : ''
            }}</span>
            <div class="right_wrap">
              <span class="sel_price">
                <vue-intl-numberformat
                  class="value"
                  format-style="decimal"
                  :currency="getCurrency.currency"
                  :number="totalPrice"
                />
                원
              </span>
              <span class="cancel" @click="removeSelect">X</span>
            </div>
          </div>
          <div class="bottom_wrap" :class="{ 'on': puchase }">
            <div
              ref="pickPrice"
              class="pick_price"
              :class="{ 'on': !optionSelect }"
            >
              <span class="f_style">총</span>
              <vue-intl-numberformat
                class="value"
                format-style="decimal"
                :currency="getCurrency.currency"
                :number="totalPrice"
              />
              원
            </div>
            <div class="cart_puchase_wrap">
              <button class="gift_btn" @click="giftNow">
                <img
                  src="data:image/svg+xml,%3Csvg width='28' height='27' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.25 13.372v11.69c0 .71-.786 1.756-1.756 1.756H3.951c-1.49 0-1.756-1.047-1.756-1.756v-11.69H0V8.115c0-.97.688-1.756 1.659-1.756h3.047c-.79-.765-1.3-1.769-1.3-3.003 0-1.522.873-3.174 3.325-3.174 3.227 0 6.005 3.435 7.651 5.923.888-2.488 3.584-5.923 6.81-5.923 2.682 0 3.516 1.652 3.516 3.174 0 1.239-.698 2.237-1.478 3.003h3.014c1.704 0 1.756.786 1.756 1.756v5.257h-1.75Zm-1.756 0h-9.666v11.69h9.666v-11.69ZM6.731 1.938c-1.085 0-1.57.43-1.57 1.39 0 1.95 2.26 3.03 4.307 3.03h2.974c-1.248-1.853-3.527-4.42-5.71-4.42Zm6.342 6.177H1.66v3.5h11.414v-3.5Zm-9.122 5.257v11.69h9.122v-11.69H3.951ZM21.192 1.938c-2.184 0-4.38 2.567-5.628 4.42h2.973c2.048 0 4.415-1.052 4.415-3.002 0-.962-.674-1.418-1.76-1.418Zm5.052 6.177H14.828v3.5h11.416v-3.5Z' fill='%23fff'/%3E%3C/svg%3E"
                  alt="선물하기"
                />
              </button>
              <button
                class="cart_btn"
                tabindex="0"
                @click="handlePurchase('cart')"
              >
                장바구니
              </button>
              <button class="buy_btn" @click="handlePurchase('buyNow')">
                바로구매
              </button>
            </div>
          </div>
        </section>
        <div class="pop_wrap" :class="{ 'db': puchase }" @click="hideBg"></div>
      </div>
      <!-- 헬프 데스크 START -->
      <!-- <HelpDesk /> -->
    </main>
  </div>
</template>
<script>
import BookDetailBox from '@/components/library/BookDetailBox.vue'
import unicolModal from '@/components/library/unicolModal.vue'
import HelpDesk from '@/components/common/HelpDesk.vue'
import { hidePaperBook, isGlobalDelivery } from '@/store/constants.js'
import {
  // ACCOUNT_GET_INFO,
  STORE_BOOK_GET,
  CART_ADD_ITEM,
  CART_GET_LIST,
  DELIVERY_LIST_GET,
  APPLICATION_CREATE,
  ONE_TOUCH_COUPON,
  ACCOUNT_UPDATE_UNICOL,
  AUTH_REFRESH,
  SUPPLEMENT_STATUS
} from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  metaInfo() {
    return {
      meta: [
        {
          vmid: 'keywords',
          name: 'keywords',
          content:
            this.getStoreCurrentBook?.title +
            ',' +
            this.getStoreCurrentBook?.author +
            ',' +
            this.getStoreCurrentBook?.keyword
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: window.location.href
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.getStoreCurrentBook?.img
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.getStoreCurrentBook?.title
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.formattedDsData
        }
      ]
    }
  },
  name: 'BookDetail',
  components: {
    HelpDesk,
    BookDetailBox,
    unicolModal
  },
  data() {
    return {
      selected: null,
      hidePaperBook,
      isGlobalDelivery,
      current: `${this.$t('views.store.bookdetail.current')}`,
      pageReady: false,
      showErrorModal: false,
      errorMessage: '',
      couponMessage: '',
      couponErrorMessage: '',
      contentMaxLength: 6,
      showDeliveryOptions: false,
      showFullContents: false,
      readOnly: true,
      activeTab: 1,
      showPodModal: false,
      showCartModal: false,
      showBuyNowModal: false,
      showAdultNursingModal: false,
      isShowUnicol: false,
      unicolCd: '',
      unicolNm: '',
      pendingAction: null,
      showRequestModal: false,
      chkGlobalBook: false,
      showCouponModal: false,
      showCouponErrorModal: false,
      selectedOptions: [],
      selectedDeliveryOptions: '',
      selectDeliveryTp: 'K',
      showDeliveryInfoFrame: false,
      deliveryInfo: {},
      isPc: false,
      isMobile: false,
      puchase: false,
      optionSelect: true,
      hiddenStates: [false, false],
      isWebView: false
    }
  },
  computed: {
    ...mapGetters([
      'isStoreBooksLoading',
      'getStoreCurrentBook',
      'getCurrentUser',
      'getCartErrorMessage',
      'getCurrency',
      'getGlobalDeliveryList',
      'getDeliveryFee',
      'getDefaultShipping',
      'getSupplementExists',
      'getSupplementFileNames'
    ]),
    responsiveContent() {
      if (this.isMobile) {
        // 모바일 버전 (들여쓰기 없음 또는 줄임)
        return '전자책 특성상 한 번 열람한 후에는 취소 및 환불이 불가능합니다. <br /> &nbsp;&nbsp;&nbsp; 미리보기를 통해 내용을 충분히 확인하신 후 신중하게 구매해 주세요.'
      } else {
        // 데스크탑 버전 (원래 들여쓰기)
        return '전자책 특성상 한 번 열람한 후에는 취소 및 환불이 불가능합니다. <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 미리보기를 통해 내용을 충분히 확인하신 후 신중하게 구매해 주세요.'
      }
    },
    isEventOpen() {
      const today = new Date()
      const startDate = new Date('2025-02-25T10:30:00') // 이벤트 시작 날짜
      const endDate = new Date('2025-04-30T23:59:59') // 이벤트 종료 날짜
      return today >= startDate && today <= endDate
    },
    showGift() {
      let x = this.getStoreCurrentBook?.bookPrice?.ebook?.options?.find(
        (e) => e.optId === 'OPT-UL'
      )
      if (x) {
        return true
      }
      return false
    },
    showPaperLink() {
      return this.getStoreCurrentBook?.paperbookLink
    },
    unlimitPrice() {
      if (!this.getStoreCurrentBook) return
      return this.getStoreCurrentBook.bookPrice.ebook.options.find(
        (e) => e.optId === 'OPT-UL'
      )
    },
    unlimitPricePaper() {
      if (!this.getStoreCurrentBook) return
      return this.getStoreCurrentBook.bookPrice.paperbook.currencies.find(
        (e) => e.currencyTp === 'KRW'
      )
    },
    isSelectPaperBook() {
      const set = this.selectedOptions.find((e) => e.type === 'paper')
      return set
    },
    getDeliveryInfo() {
      return this.deliveryInfo
    },
    localCurrencyPrice() {
      const currencyBook = {}
      if (this.getCurrency.currency !== 'KRW') {
        let mapping = this.unlimitPrice.currencies.find((e) => {
          return e.currencyTp === this.getCurrency.currency
        })
        currencyBook.price = mapping.listPrice
        currencyBook.salePrice = mapping.salePrice
      }
      return this.getCurrency.currency === 'KRW'
        ? {
            price: this.unlimitPrice.listPrice,
            salePrice: this.unlimitPrice.salePrice
          }
        : {
            price: currencyBook.price,
            salePrice: currencyBook.salePrice
          }
    },
    totalCount() {
      return this.selectedOptions.reduce((total, option) => {
        return total + option.quantity
      }, 0)
    },
    subTotal() {
      const total = this.selectedOptions[0]?.salePrice || 0
      return total
    },
    totalShipping() {
      if (!this.subTotal) {
        return 0
      }
      if (!this.getStoreCurrentBook.buyTp.paperbook) {
        return 0
      }
      if (!this.isSelectPaperBook) {
        return 0
      }
      if (this.selectDeliveryTp === 'K') {
        return this.getDefaultShipping.paperbookCurrencyList.find(
          (e) => e.currencyTp === this.getCurrency.currency
        ).listPrice
      }
      if (
        this.selectDeliveryTp != 'K' &&
        this.getDeliveryFee &&
        this.getDeliveryFee.emsFeeCurrencyList
      ) {
        return this.getDeliveryFee.emsFeeCurrencyList.find(
          (e) => e.currencyTp === this.getCurrency.currency
        ).listPrice
      }
      return 0
    },
    totalPrice() {
      return this.totalShipping + this.subTotal
    },
    isContentLong() {
      if (
        this.pageReady &&
        this.$refs.contents &&
        (this.$refs.contents.childNodes.length > this.contentMaxLength ||
          this.getStoreCurrentBook.contents.split('<br />').length >
            this.contentMaxLength)
      ) {
        return true
      }
      return false
    },
    formattedDescription() {
      return this.getStoreCurrentBook.description
    },
    formattedDsData() {
      const description = this.getStoreCurrentBook?.description || ''
      if (description.length > 77) {
        return description.substring(0, 77) + '..'
      }
      return description
    },
    formattedAuthorDescription() {
      return this.getStoreCurrentBook.authorIntro
    },
    formattedContents() {
      if (!this.showFullContents && this.isContentLong) {
        return this.getStoreCurrentBook.contents
          .split('<br />')
          .filter((item) => item !== '')
          .slice(0, this.contentMaxLength)
          .join('<br />')
      }
      return this.getStoreCurrentBook.contents
    },
    checkEbookOnly() {
      if (this.getStoreCurrentBook?.ebookOnly === 'Y') {
        return true
      }
      return false
    },
    bookTp() {
      if (this.getStoreCurrentBook?.bookTp === 'BUNDLE') {
        return 'BUNDLE'
      }
      return 'BOOK'
    },
    deliveryFeeOption() {
      const set = this.selectedOptions.find((e) => e.type === 'paper')
      if (!set || !this.selectedDeliveryOptions) {
        return ''
      }
      const payload = {
        emsTp: this.selectDeliveryTp || '',
        emsAreaCd: this.selectedDeliveryOptions.emsAreaCd,
        emsCountryCd: this.selectedDeliveryOptions.emsCountryCd || '',
        units: set.quantity || 0,
        bookWeight: this.getStoreCurrentBook.bookWeight || 0,
        bookSize: this.getStoreCurrentBook.bookSize || ''
      }
      return payload
    },
    paperPerEBookDiscount() {
      let paper = this.unlimitPricePaper.listPrice
      let ebook = this.localCurrencyPrice.price
      return Math.floor(((paper - ebook) / paper) * 100)
    },
    bookCategory() {
      const catgry = {
        code: this.getStoreCurrentBook.categories[0].id || '0031',
        label: this.getStoreCurrentBook.categories[0].label.split('>')[0]
      }
      return catgry
    },
    bookSubCategory() {
      const subcatgry = {
        code: this.getStoreCurrentBook.categories[0].subCatgryCd || '',
        label: this.getStoreCurrentBook.categories[0].label.split('>')[1]
      }
      return subcatgry
    },
    isLoggedIn() {
      return this.getCurrentUser
    },
    isTeacher() {
      if (!this.isLoggedIn || this.getCurrentUser?.memberTp !== '2000')
        return false
      return true
    },
    isEbookEvent() {
      let salePrice = this.getStoreCurrentBook?.bookPrice?.ebook?.options.find(
        (e) => e.optDesc === '대여(6개월)'
      )?.salePrice
      let listPrice = this.getStoreCurrentBook?.bookPrice?.ebook?.options.find(
        (e) => e.optDesc === '대여(6개월)'
      )?.listPrice
      if (salePrice < listPrice) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    selectedDeliveryOptions() {
      if (!this.deliveryFeeOption) return
      this.$store.dispatch('fetchDeliveryFee', this.deliveryFeeOption)
    },
    selectedOptions: {
      deep: true,
      handler() {
        if (this.selectDeliveryTp === 'K') return
        if (!this.deliveryFeeOption) return
        this.$store.dispatch('fetchDeliveryFee', this.deliveryFeeOption)
      }
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (
      to.name === 'book_detail' &&
      this.getStoreCurrentBook.id !== to.params.id
    ) {
      try {
        this.pageReady = false
        await this.$store.dispatch(STORE_BOOK_GET, to.params.id)
        await this.$store.dispatch(SUPPLEMENT_STATUS, to.params.id)
        this.pageReady = true
        this.setActiveTab(1)
        next()
      } catch (err) {
        console.log(err)
      }
    }
  },
  async mounted() {
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
    if (
      !this.getStoreCurrentBook ||
      this.getStoreCurrentBook.id !== this.$route.params.id
    ) {
      try {
        await this.$store.dispatch(STORE_BOOK_GET, this.$route.params.id)
        await this.$store.dispatch(SUPPLEMENT_STATUS, this.$route.params.id)
      } catch (err) {
        console.log(err)
      }
    }
    if (!this.getGlobalDeliveryList && this.isGlobalDelivery) {
      try {
        await this.fetchAreaList(this.selectDeliveryTp)
      } catch (err) {
        console.log(err)
      }
    }
    this.pageReady = true
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth >= 481
      this.isMobile = window.innerWidth <= 480
    },
    isEventOption(opt) {
      return opt?.listPrice > opt?.salePrice
    },
    activeListOpt(idx) {
      this.selected = idx
    },
    fetchAreaList(tp) {
      if (
        this.selectedDeliveryOptions['emsTp'] &&
        this.selectedDeliveryOptions.emsTp !== tp
      ) {
        this.selectedDeliveryOptions = false
      }
      this.$store.dispatch(DELIVERY_LIST_GET, tp)
    },
    setActiveTab(value) {
      this.activeTab = value
    },
    togglePodModal() {
      this.showPodModal = !this.showPodModal
    },
    toggleCartModal() {
      this.showCartModal = !this.showCartModal
    },
    toggleBuyNowModal() {
      this.showBuyNowModal = !this.showBuyNowModal
    },
    toggleAdultNursingModal() {
      this.showAdultNursingModal = !this.showAdultNursingModal
    },
    toggleUnicolModal() {
      this.isShowUnicol = !this.isShowUnicol
    },
    toggleCouponModal() {
      this.showCouponModal = !this.showCouponModal
    },
    toggleCouponErrorModal() {
      this.showCouponErrorModal = !this.showCouponErrorModal
    },
    toggleExplain(index) {
      this.$set(this.hiddenStates, index, !this.hiddenStates[index])
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el) {
      const height = el.scrollHeight
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = `${height}px`
      el.style.opacity = '1'
    },
    leave(el) {
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },
    navigateToCart() {
      this.$router.push({ name: 'cart' })
    },
    navigateToCoupon() {
      this.$router.push({ name: 'discount' })
    },
    showInViewer() {
      let chkAppUser = navigator.userAgent.toLowerCase()
      const isPreferredBrowser =
        chkAppUser.indexOf('chrome') > -1 ||
        chkAppUser.indexOf('safari') > -1 ||
        chkAppUser.indexOf('samsungbrowser') > -1

      const isKakaoTalk = chkAppUser.indexOf('kakaotalk') > -1

      // 권장 브라우저가 아니거나 카카오톡인 경우 경고 표시
      if (!isPreferredBrowser || isKakaoTalk) {
        this.isWebView = true
        alert(
          '현재 사용중인 브라우저에서는 도서 열람을 하실 경우 화면오류 또는 성능저하가 발생할 수 있습니다. 원활한 이용을 위해 Chrome, Safari, 또는 삼성 브라우저를 사용해주시기 바랍니다.'
        )
      }
      window.open(this.getStoreCurrentBook.previewUrl, '_blank', '')
    },
    selectPurchaseOption(option) {
      this.selectedOptions = []
      this.selectedOptions.push({ ...option })
    },
    toggleContents() {
      this.showFullContents = !this.showFullContents
    },
    formatCartData(isGift) {
      const items = {
        purchase: {
          cartBooksList: [
            {
              buyOptTp: isGift ? 'GFT' : 'PMT',
              buyAmt: 1,
              bookTp: this.bookTp,
              buyTp: {
                paperbook: false,
                ebook: true,
                pod: false
              },
              bookPrice: {
                paperbook: 0,
                ebook: {
                  optId: this.selectedOptions[0].optId,
                  price: Number(this.selectedOptions[0].salePrice)
                },
                pod: { profileId: null }
              }
            }
          ]
        }
      }
      return items
    },
    toggleErrorModal(message) {
      if (message) {
        this.errorMessage = message
      }
      this.showErrorModal = !this.showErrorModal
    },
    selectUnicol(school) {
      if (!school) {
        this.toggleUnicolModal()
        return
      }
      this.toggleUnicolModal()
      this.unicolNm = school.unicolNm
      this.unicolCd = school.unicolCd
    },
    async goBuyNow() {
      this.chkGlobalBook = true
      this.buyNow()
    },
    async giftNow() {
      if (!this.getCurrentUser) {
        this.$router.push({ name: 'login' })
        return
      }
      if (!this.selectedOptions.length) {
        this.toggleErrorModal(this.$i18n.t('views.store.bookdetail.7884'))
        return
      }
      if (this.selectedOptions[0].optId !== 'OPT-UL') {
        this.toggleErrorModal('선물하기는 구매(소장) 옵션으로만 가능합니다.')
        return
      }
      const item = this.formatCartData(true)
      try {
        await this.$store.dispatch(CART_ADD_ITEM, {
          id: this.getStoreCurrentBook.id,
          item
        })
        // Reload cart
        await this.$store.dispatch(CART_GET_LIST)
        this.$router.push({ name: 'cart' })
      } catch (err) {
        if (err.response && err.response.data.errorState) {
          this.toggleErrorModal(
            `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
          )
        }
      }
    },
    closeDeliveryInfoToggle() {
      this.showDeliveryInfoFrame = false
    },
    toggleRequestModal() {
      this.showRequestModal = !this.showRequestModal
    },
    async requestPresent() {
      if (this.isTeacher) {
        let memberCode = this.getCurrentUser?.memberId
        let bookCode = this.getStoreCurrentBook?.id
        // 버튼 클릭 -> 요청하시겠습니까? Y/N -> 요청에 성공하였습니다. 예정
        await this.$store
          .dispatch(APPLICATION_CREATE, { memberCode, bookCode })
          .then((res) => {
            console.log(res)
            if (res.data.ok) {
              alert(
                '증정 요청에 성공했습니다.\n출판사에 요청메일을 발송했습니다.'
              )
            }
          })
          .catch((err) => {
            alert(err.response.data.errorState.message)
          })
        this.toggleRequestModal()
      }
    },
    async oneTouchCouponDownload() {
      if (!this.getCurrentUser) {
        if (confirm('로그인이 필요합니다. 로그인 하시겠습니까?')) {
          this.$router.push({ name: 'login' })
          return
        } else {
          return
        }
      }
      // 이 아래 쿠폰 받기 구현.
      // 클릭하면 받으시겠습니까? 질문 없이 즉시 받기
      // 받고나서 확인 + 쿠폰함 이동 버튼 - LIKE 책을 장바구니에 넣었을 때처럼

      // 쿠폰 수령 후 알림창 띄워주는 부분.
      // 알림창은 장바구니 부분을 참고하여 만들어 짐.
      let resp = await this.$store.dispatch(ONE_TOUCH_COUPON)
      let result = resp.data.result
      switch (result.state) {
        case 'success':
          this.couponMessage = result.modal
          this.showCouponModal = true
          break
        case 'fail':
          this.couponErrorMessage = result.modal
          this.showCouponErrorModal = true
          break
        case 'error':
          alert(result.message)
          break
        default:
          console.log('out of case')
      }
    },
    showPuchase() {
      this.puchase = !this.puchase
    },
    hideBg() {
      this.puchase = false
    },
    optionChoice() {
      this.optionSelect = !this.optionSelect
      if (!this.selectedOptions.length) {
        this.$nextTick(() => {
          this.$refs.selectedItem.classList.remove('on')
          this.$refs.pickPrice.classList.remove('on')
        })
      }
    },
    removeSelect() {
      this.selectedOptions = []
      this.$refs.selectedItem.classList.remove('on')
      this.$refs.pickPrice.classList.remove('on')
    },
    async handlePurchase(action) {
      this.pendingAction = action
      if (!this.getCurrentUser) {
        this.$router.push({ name: 'login' })
        return
      }
      if (!this.selectedOptions.length) {
        this.toggleErrorModal(this.$i18n.t('views.store.bookdetail.7884'))
        return
      }
      if (
        (this.getStoreCurrentBook.id === 'BO-20240823000100003' || // 성인간호학
        this.getStoreCurrentBook.id === 'BO-20240823000100002' || // 성인간호학
        this.getStoreCurrentBook.id === 'BO-20250311000100001' || // 작업치료학개론 5판
        this.getStoreCurrentBook.id === 'BO-20250206000100001' || // 아동간호학 3판
          this.getStoreCurrentBook.bookTp === 'BUNDLE') &&
        !this.getCurrentUser.unicolNm
      ) {
        this.showAdultNursingModal = true
        return
      }
      await this.executePurchase()
    },
    async executePurchase() {
      try {
        const item = this.createCartItem()
        if (!item) return // createCartItem에서 오류 발생 시 종료
        const res = await this.$store.dispatch(CART_ADD_ITEM, {
          id: this.getStoreCurrentBook.id,
          item
        })
        const cartCd = res.data.result.purchase.cartId
        await this.$store.dispatch(CART_GET_LIST)
        this.handlePostPurchaseAction(cartCd)
      } catch (err) {
        this.handlePurchaseError(err)
      } finally {
        this.pendingAction = null // 작업 후 상태 초기화
      }
    },
    createCartItem() {
      if (
        this.pendingAction === 'gift' &&
        this.selectedOptions[0].optId !== 'OPT-UL'
      ) {
        this.toggleErrorModal('선물하기는 구매(소장) 옵션으로만 가능합니다.')
        return null // 오류 발생 시 null 반환
      }
      return this.formatCartData(this.pendingAction === 'gift')
    },
    handlePostPurchaseAction(cartCd) {
      if (this.pendingAction === 'cart') {
        this.showCartModal = true
      } else if (['buyNow', 'gift'].includes(this.pendingAction)) {
        this.$router.push({ name: 'cart', params: { cartCd } })
      }
    },
    handlePurchaseError(err) {
      if (err.response && err.response.data.errorState) {
        this.toggleErrorModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    },
    async college_register() {
      if (!this.unicolNm) {
        alert('학교를 선택해주세요.')
        return
      }
      try {
        await this.$store.dispatch(ACCOUNT_UPDATE_UNICOL, {
          unicolCode: this.unicolCd
        })
        await this.$store.dispatch(AUTH_REFRESH)
        if (this.pendingAction) {
          await this.executePurchase()
        }
      } catch (err) {
        this.handlePurchaseError(err)
      } finally {
        this.showAdultNursingModal = false // 모달 닫기
      }
    }
  }
}
</script>
<style src="@/assets/css/apply/page_book_shared.css" scoped></style>
<style src="@/assets/css/book_detail.css" scoped></style>
